import React from 'react';
import { useTheme } from '../context/themeProvider';

const GlobalModal = ({ opened, onClose, children }) => {
  const { colorScheme } = useTheme();
  const isDarkTheme = colorScheme === 'dark';
  return (
    <div
      className={`fixed inset-0 z-[3000] flex items-end justify-center bg-black/50 transition-opacity duration-300 ease-in-out ${
        opened ? 'opacity-100' : 'pointer-events-none opacity-0'
      }`}
      onClick={onClose}
    >
      <div
        className={`w-full max-w-[28rem] transform rounded-t-2xl pt-5 ${
          isDarkTheme ? 'bg-[#303034]' : 'bg-white'
        } transition-all duration-300 ease-[cubic-bezier(0.4,0,0.2,1)] ${
          opened ? 'translate-y-0' : 'translate-y-full'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

export default GlobalModal;
